import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	createProject: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	createProjectGalaxia: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	createProjectDisabledTooltip: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	createProject: {
		id: 'projects-directory-v3.page-layout.header.create-project-action.create-project',
		defaultMessage: 'Create project',
		description: 'Label of create project button',
	},
	createProjectGalaxia: {
		id: 'projects-directory-v3.page-layout.header.create-project-action.create-project-galaxia',
		defaultMessage: 'Create space',
		description: 'Label of create project button',
	},
	createProjectDisabledTooltip: {
		id: 'projects-directory-v3.page-layout.header.create-project-action.create-project-disabled-tooltip',
		defaultMessage:
			'You do not have permission to create projects. Please contact your administrator.',
		description: 'Tooltip text for create project button when user does not have permission',
	},
});
export default messages;
